/**
 * File: useNavActiveState.ts
 * Path: apps/admin/src/modules/layout/hooks/useNavActiveState.ts
 * Description: Says whether a menu link is the page being shown. On a business page (/businesses/:id) the
 * record's stage decides the link: Pipeline while it is an open lead, Clients once won or past.
 */

import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useLead } from "@/shared/hooks/useLeadsQueries";
import { businessIdFromPath, isNavCurrent } from "@/modules/layout/utils/navActiveUtils";

export const useNavActiveState = () => {
  const { pathname } = useLocation();
  const businessId = businessIdFromPath(pathname) ?? undefined;
  const lead = useLead(businessId);
  // undefined while loading; null when there is no lead side (a client that never was a lead).
  const stage = businessId === undefined || lead.isLoading ? undefined : (lead.data?.stage ?? null);

  const isActive = useCallback(
    (href: string | undefined) => isNavCurrent(pathname, href, stage),
    [pathname, stage],
  );

  return { pathname, isActive };
};
